/* eslint-disable */

// @ts-nocheck

// This file was automatically generated by @icp-sdk/bindgen@0.4.0.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { IDL } from '@icp-sdk/core/candid';

export const idlFactory = ({ IDL }) => {
  const MemberStatus = IDL.Variant({
    'active' : IDL.Null,
    'pending' : IDL.Null,
    'invited' : IDL.Null,
    'inactive' : IDL.Null,
    'rejected' : IDL.Null,
    'suspended' : IDL.Null,
  });
  const Text = IDL.Text;
  const Time = IDL.Int;
  const Member = IDL.Record({
    'id' : IDL.Nat,
    'status' : IDL.Opt(MemberStatus),
    'roleName' : IDL.Opt(Text),
    'communityId' : IDL.Opt(IDL.Nat),
    'name' : Text,
    'role' : IDL.Opt(Text),
    'profileId' : IDL.Opt(IDL.Nat),
    'lastChange' : Time,
    'communityName' : IDL.Opt(Text),
    'profilePrincipal' : IDL.Opt(IDL.Principal),
    'statusName' : IDL.Opt(Text),
    'tutorId' : IDL.Opt(IDL.Nat),
    'tutorName' : IDL.Opt(Text),
  });
  const Result_3 = IDL.Variant({ 'ok' : Member, 'err' : IDL.Vec(IDL.Text) });
  const Community = IDL.Record({
    'id' : IDL.Nat,
    'ownerName' : IDL.Opt(Text),
    'ownerId' : IDL.Nat,
    'name' : Text,
    'ownerProfileId' : IDL.Opt(IDL.Nat),
    'lastChange' : Time,
  });
  const Result_6 = IDL.Variant({ 'ok' : Community, 'err' : IDL.Vec(IDL.Text) });
  const EventStatus = IDL.Variant({
    'pending' : IDL.Null,
    'approved' : IDL.Null,
    'rejected' : IDL.Null,
  });
  const Event = IDL.Record({
    'id' : IDL.Nat,
    'status' : EventStatus,
    'memberId' : IDL.Nat,
    'approvedByName' : IDL.Opt(Text),
    'tokensPerUnit' : IDL.Nat,
    'eventTypeName' : IDL.Opt(Text),
    'approvedById' : IDL.Opt(IDL.Nat),
    'lastChange' : Time,
    'memberName' : IDL.Opt(Text),
    'timestamp' : Time,
    'eventTypeId' : IDL.Nat,
    'statusName' : IDL.Opt(Text),
    'tokensImpact' : IDL.Opt(Text),
    'amount' : IDL.Nat,
    'profileName' : IDL.Opt(Text),
  });
  const Result_4 = IDL.Variant({ 'ok' : Event, 'err' : IDL.Vec(IDL.Text) });
  const ExternalEventInput = IDL.Record({
    'memberId' : IDL.Nat,
    'eventTypeId' : IDL.Nat,
    'amount' : IDL.Nat,
  });
  const ExternalLinkedProfileEventInput = IDL.Record({
    'zenquestProfilePrincipal' : IDL.Principal,
    'kudosProfilePrincipal' : IDL.Principal,
    'eventTypeId' : IDL.Nat,
    'amount' : IDL.Nat,
  });
  const Result_12 = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Vec(IDL.Text) });
  const Role = IDL.Variant({ 'admin' : IDL.Null, 'user' : IDL.Null });
  const Language = IDL.Variant({ 'en' : IDL.Null, 'ptbr' : IDL.Null });
  const Profile = IDL.Record({
    'id' : IDL.Nat,
    'userName' : Text,
    'principal' : IDL.Principal,
    'country' : IDL.Opt(Text),
    'displayName' : IDL.Opt(Text),
    'role' : Role,
    'userBio' : IDL.Opt(Text),
    'email' : IDL.Opt(Text),
    'language' : Language,
    'zenquestPrincipal' : IDL.Opt(IDL.Principal),
    'lastChange' : Time,
    'avatar' : IDL.Opt(IDL.Vec(IDL.Nat8)),
  });
  const Result_2 = IDL.Variant({ 'ok' : Profile, 'err' : IDL.Vec(IDL.Text) });
  const EventCategory = IDL.Variant({
    'reward' : IDL.Null,
    'punishment' : IDL.Null,
    'effort' : IDL.Null,
  });
  const EventType = IDL.Record({
    'id' : IDL.Nat,
    'tokenId' : IDL.Nat,
    'name' : Text,
    'unit' : Text,
    'eventCategoryName' : IDL.Opt(Text),
    'eventCategory' : EventCategory,
    'tokensPerUnit' : IDL.Nat,
    'rewardProgramId' : IDL.Nat,
    'lastChange' : Time,
    'tokenName' : IDL.Opt(Text),
    'requiresApproval' : IDL.Bool,
    'defaultValue' : IDL.Nat,
  });
  const RewardProgram = IDL.Record({
    'id' : IDL.Nat,
    'communityId' : IDL.Nat,
    'name' : Text,
    'description' : IDL.Opt(Text),
    'lastChange' : Time,
    'communityName' : IDL.Opt(Text),
    'eventTypes' : IDL.Vec(EventType),
  });
  const Result_1 = IDL.Variant({
    'ok' : RewardProgram,
    'err' : IDL.Vec(IDL.Text),
  });
  const Token = IDL.Record({
    'id' : IDL.Nat,
    'communityId' : IDL.Nat,
    'name' : Text,
    'lastChange' : Time,
    'communityName' : IDL.Opt(Text),
    'symbol' : Text,
  });
  const Result = IDL.Variant({ 'ok' : Token, 'err' : IDL.Vec(IDL.Text) });
  const ReferenceAuditViolation = IDL.Record({
    'missingTargetIds' : IDL.Vec(IDL.Text),
    'message' : IDL.Text,
    'targetRole' : IDL.Text,
    'targetEntity' : IDL.Text,
  });
  const DaoAuditEntry = IDL.Record({
    'violations' : IDL.Vec(ReferenceAuditViolation),
    'sourceId' : IDL.Nat,
  });
  const DaoAuditChunk = IDL.Record({
    'scanned' : IDL.Nat,
    'entries' : IDL.Vec(DaoAuditEntry),
    'nextKey' : IDL.Opt(IDL.Nat),
  });
  const Result_13 = IDL.Variant({ 'ok' : DaoAuditChunk, 'err' : IDL.Text });
  const ExternalCanisterAuthorization = IDL.Record({
    'id' : IDL.Nat,
    'revokedByName' : IDL.Opt(Text),
    'active' : IDL.Bool,
    'approvedByName' : IDL.Opt(Text),
    'communityId' : IDL.Nat,
    'canisterPrincipalText' : IDL.Opt(Text),
    'approvedAt' : Time,
    'canisterPrincipal' : IDL.Principal,
    'lastChange' : Time,
    'communityName' : IDL.Opt(Text),
    'eventTypeIds' : IDL.Vec(IDL.Nat),
    'approvedByProfileId' : IDL.Nat,
    'revokedByProfileId' : IDL.Opt(IDL.Nat),
    'revokedAt' : IDL.Opt(Time),
  });
  const Result_9 = IDL.Variant({
    'ok' : ExternalCanisterAuthorization,
    'err' : IDL.Vec(IDL.Text),
  });
  const Result_8 = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const BackupBlobEntry = IDL.Record({
    'key' : IDL.Nat,
    'payLoad' : IDL.Vec(IDL.Nat8),
  });
  const BackupChunk = IDL.Record({
    'entries' : IDL.Vec(BackupBlobEntry),
    'nextKey' : IDL.Opt(IDL.Nat),
  });
  const Result_11 = IDL.Variant({ 'ok' : BackupChunk, 'err' : IDL.Text });
  const LogLevel = IDL.Variant({
    'deb' : IDL.Null,
    'warning' : IDL.Null,
    'info' : IDL.Null,
    'error' : IDL.Null,
  });
  const Configuration = IDL.Record({
    'id' : IDL.Nat,
    'maxProfileImageSize' : IDL.Nat,
    'logLevel' : LogLevel,
    'lastChange' : Time,
    'eventsForCacheWarmup' : IDL.Nat,
  });
  const Result_10 = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text });
  const TokenPoint = IDL.Record({
    'eventTypeName' : IDL.Text,
    'spent' : IDL.Nat,
    'timestamp' : Time,
    'tokenName' : IDL.Text,
    'received' : IDL.Nat,
  });
  const RepositoryStats = IDL.Record({
    'objectsInCache' : IDL.Nat,
    'usedMemory' : IDL.Nat,
    'allocatedPages' : IDL.Nat,
    'objectCount' : IDL.Nat,
    'freeMemory' : IDL.Nat,
  });
  const AllRepositoryStats = IDL.Record({
    'member' : RepositoryStats,
    'token' : RepositoryStats,
    'community' : RepositoryStats,
    'event' : RepositoryStats,
    'externalCanisterAuthorization' : RepositoryStats,
    'rewardProgram' : RepositoryStats,
    'profile' : RepositoryStats,
    'eventType' : RepositoryStats,
  });
  const RuntimeMemoryReport = IDL.Record({
    'heapBytes' : IDL.Nat,
    'wasmBytes' : IDL.Nat,
  });
  const RepositoryReport = IDL.Record({
    'member' : RepositoryStats,
    'token' : RepositoryStats,
    'community' : RepositoryStats,
    'event' : RepositoryStats,
    'externalCanisterAuthorization' : RepositoryStats,
    'rewardProgram' : RepositoryStats,
    'profile' : RepositoryStats,
    'eventType' : RepositoryStats,
  });
  const Result_7 = IDL.Variant({ 'ok' : IDL.Vec(IDL.Text), 'err' : IDL.Text });
  const Result_5 = IDL.Variant({
    'ok' : Configuration,
    'err' : IDL.Vec(IDL.Text),
  });
  
  return IDL.Service({
    'acceptInvite' : IDL.Func([IDL.Nat], [Result_3], []),
    'addCommunity' : IDL.Func([Community], [Result_6], []),
    'addEvent' : IDL.Func([Event], [Result_4], []),
    'addExternalEvent' : IDL.Func([ExternalEventInput], [Result_4], []),
    'addExternalEventForLinkedProfile' : IDL.Func(
        [ExternalLinkedProfileEventInput],
        [Result_12],
        [],
      ),
    'addMember' : IDL.Func([Member], [Result_3], []),
    'addMyProfile' : IDL.Func([Profile], [Result_2], []),
    'addRewardProgram' : IDL.Func([RewardProgram], [Result_1], []),
    'addToken' : IDL.Func([Token], [Result], []),
    'approveEvent' : IDL.Func([IDL.Nat], [Result_4], []),
    'auditDaoChunk' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Nat), IDL.Opt(IDL.Nat)],
        [Result_13],
        ['query'],
      ),
    'authorizeExternalCanister' : IDL.Func(
        [
          IDL.Record({
            'communityId' : IDL.Nat,
            'canisterPrincipal' : IDL.Principal,
            'eventTypeIds' : IDL.Vec(IDL.Nat),
          }),
        ],
        [Result_9],
        [],
      ),
    'clearCache' : IDL.Func([], [], []),
    'clearDao' : IDL.Func([IDL.Text], [Result_8], []),
    'createMyProfile' : IDL.Func([], [Profile], []),
    'deleteCommunity' : IDL.Func([IDL.Nat], [Result_12], []),
    'deleteEvent' : IDL.Func([IDL.Nat], [Result_12], []),
    'deleteMember' : IDL.Func([IDL.Nat], [Result_12], []),
    'deleteProfile' : IDL.Func([IDL.Nat], [Result_12], []),
    'deleteRewardProgram' : IDL.Func([IDL.Nat], [Result_12], []),
    'deleteToken' : IDL.Func([IDL.Nat], [Result_12], []),
    'demoteFromAdmin' : IDL.Func([IDL.Nat], [Result_2], []),
    'getAllCommunities' : IDL.Func([], [IDL.Vec(Community)], ['query']),
    'getAllMembers' : IDL.Func([], [IDL.Vec(Member)], ['query']),
    'getAllTokens' : IDL.Func([], [IDL.Vec(Token)], ['query']),
    'getAuditableDaoIdentifiers' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'getBlobEntries' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Nat), IDL.Opt(IDL.Nat)],
        [Result_11],
        ['query'],
      ),
    'getCommunity' : IDL.Func([IDL.Nat], [IDL.Opt(Community)], ['query']),
    'getCommunityExternalCanisterAuthorizations' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(ExternalCanisterAuthorization)],
        ['query'],
      ),
    'getCommunityMembers' : IDL.Func([IDL.Nat], [IDL.Vec(Member)], ['query']),
    'getCommunityMembersPaginated' : IDL.Func(
        [
          IDL.Record({
            'sortField' : IDL.Text,
            'filters' : IDL.Text,
            'communityId' : IDL.Nat,
            'sortOrder' : IDL.Text,
            'pageSize' : IDL.Nat,
            'start' : IDL.Nat,
          }),
        ],
        [IDL.Vec(Member), IDL.Nat],
        ['query'],
      ),
    'getCommunityRewardPrograms' : IDL.Func(
        [IDL.Nat],
        [IDL.Vec(RewardProgram)],
        ['query'],
      ),
    'getCommunityTokens' : IDL.Func([IDL.Nat], [IDL.Vec(Token)], ['query']),
    'getConfiguration' : IDL.Func([], [Configuration], ['query']),
    'getDaoIdentifiers' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'getDaoSequence' : IDL.Func([IDL.Text], [Result_10], ['query']),
    'getDaoSize' : IDL.Func([IDL.Text], [Result_10], ['query']),
    'getEvent' : IDL.Func([IDL.Nat], [IDL.Opt(Event)], ['query']),
    'getEventType' : IDL.Func([IDL.Nat], [IDL.Opt(EventType)], ['query']),
    'getJoinedCommunities' : IDL.Func([], [IDL.Vec(Community)], ['query']),
    'getMember' : IDL.Func([IDL.Nat], [IDL.Opt(Member)], ['query']),
    'getMemberEvents' : IDL.Func([IDL.Nat], [IDL.Vec(Event)], ['query']),
    'getMemberEventsPaginated' : IDL.Func(
        [
          IDL.Record({
            'memberId' : IDL.Nat,
            'sortField' : IDL.Text,
            'filters' : IDL.Text,
            'sortOrder' : IDL.Text,
            'pageSize' : IDL.Nat,
            'start' : IDL.Nat,
          }),
        ],
        [IDL.Vec(Event), IDL.Nat],
        ['query'],
      ),
    'getMembers' : IDL.Func(
        [
          IDL.Record({
            'sortField' : IDL.Text,
            'filters' : IDL.Text,
            'sortOrder' : IDL.Text,
            'pageSize' : IDL.Nat,
            'start' : IDL.Nat,
          }),
        ],
        [IDL.Vec(Member), IDL.Nat],
        ['query'],
      ),
    'getMyCommunities' : IDL.Func([], [IDL.Vec(Community)], ['query']),
    'getMyEvents' : IDL.Func([], [IDL.Vec(Event)], ['query']),
    'getMyEventsPaginated' : IDL.Func(
        [
          IDL.Record({
            'sortField' : IDL.Text,
            'filters' : IDL.Text,
            'sortOrder' : IDL.Text,
            'pageSize' : IDL.Nat,
            'start' : IDL.Nat,
          }),
        ],
        [IDL.Vec(Event), IDL.Nat],
        ['query'],
      ),
    'getMyInvites' : IDL.Func([], [IDL.Vec(Member)], ['query']),
    'getMyInvitesPaginated' : IDL.Func(
        [
          IDL.Record({
            'sortField' : IDL.Text,
            'filters' : IDL.Text,
            'sortOrder' : IDL.Text,
            'pageSize' : IDL.Nat,
            'start' : IDL.Nat,
          }),
        ],
        [IDL.Vec(Member), IDL.Nat],
        ['query'],
      ),
    'getMyMembership' : IDL.Func([IDL.Nat], [IDL.Opt(Member)], ['query']),
    'getMyProfile' : IDL.Func([], [IDL.Opt(Profile)], ['query']),
    'getMyTokensSeries' : IDL.Func([], [IDL.Vec(TokenPoint)], ['query']),
    'getMyTutoredMembers' : IDL.Func([], [IDL.Vec(Member)], ['query']),
    'getProfiles' : IDL.Func(
        [
          IDL.Record({
            'sortField' : IDL.Text,
            'filters' : IDL.Text,
            'sortOrder' : IDL.Text,
            'pageSize' : IDL.Nat,
            'start' : IDL.Nat,
          }),
        ],
        [IDL.Vec(Profile), IDL.Nat],
        ['query'],
      ),
    'getRepositoryStats' : IDL.Func([], [AllRepositoryStats], []),
    'getRewardProgram' : IDL.Func(
        [IDL.Nat],
        [IDL.Opt(RewardProgram)],
        ['query'],
      ),
    'getToken' : IDL.Func([IDL.Nat], [IDL.Opt(Token)], ['query']),
    'getTranslations' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        ['query'],
      ),
    'getTutorMembers' : IDL.Func([IDL.Nat], [IDL.Vec(Member)], ['query']),
    'getTutoredMembers' : IDL.Func([IDL.Nat], [IDL.Vec(Member)], ['query']),
    'getVersion' : IDL.Func([], [IDL.Nat], []),
    'hasCommunityMembers' : IDL.Func([IDL.Nat], [IDL.Bool], ['query']),
    'hasProfiles' : IDL.Func([], [IDL.Bool], ['query']),
    'hasTutorMembers' : IDL.Func([IDL.Nat], [IDL.Bool], ['query']),
    'inviteMember' : IDL.Func([IDL.Principal, IDL.Nat], [Result_3], []),
    'isAdmin' : IDL.Func([], [IDL.Bool], ['query']),
    'isMaintenanceMode' : IDL.Func([], [IDL.Bool], ['query']),
    'memory' : IDL.Func([], [RuntimeMemoryReport], []),
    'promoteToAdmin' : IDL.Func([IDL.Nat], [Result_2], []),
    'putBlobEntries' : IDL.Func(
        [IDL.Text, IDL.Vec(BackupBlobEntry)],
        [Result_10],
        [],
      ),
    'reindexDao' : IDL.Func([IDL.Text], [Result_8], []),
    'rejectEvent' : IDL.Func([IDL.Nat], [Result_4], []),
    'rejectInvite' : IDL.Func([IDL.Nat], [Result_3], []),
    'repositories' : IDL.Func([], [RepositoryReport], []),
    'revokeExternalCanister' : IDL.Func(
        [
          IDL.Record({
            'communityId' : IDL.Nat,
            'canisterPrincipal' : IDL.Principal,
          }),
        ],
        [Result_9],
        [],
      ),
    'setDaoSequence' : IDL.Func([IDL.Text, IDL.Nat], [Result_8], []),
    'setMaintenanceMode' : IDL.Func([IDL.Bool], [IDL.Bool], []),
    'startRestore' : IDL.Func([IDL.Vec(IDL.Text)], [Result_7], []),
    'updateCommunity' : IDL.Func([Community], [Result_6], []),
    'updateConfiguration' : IDL.Func([Configuration], [Result_5], []),
    'updateEvent' : IDL.Func([Event], [Result_4], []),
    'updateMember' : IDL.Func([Member], [Result_3], []),
    'updateMyProfile' : IDL.Func([Profile], [Result_2], []),
    'updateRewardProgram' : IDL.Func([RewardProgram], [Result_1], []),
    'updateToken' : IDL.Func([Token], [Result], []),
    'warmupCache' : IDL.Func([], [], []),
  });
};

export const init = ({ IDL }) => { return []; };